import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';


@Component({
  selector: 'comp-view-name-desc-lang',
  templateUrl: 'view-name-desc-lang.html',
})
export class ViewNameDescLangPage {
  @Input() lang: any;
  @Input() value_es: any;
  @Input() value_ca: any;
  @Input() value_en: any;
  @Input() value_de: any;
  @Input() value_it: any;
  @Input() value_fr: any;
  @Input() origin: any;
  @Input() type: any;

  _description: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,) {
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/view-name-desc-lang/view-name-desc-lang.ts